package pl.decks.personal.components.layouts.site

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.core.data.addIfAbsent
import com.varabyte.kobweb.core.data.getValue
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.browser.document
import pl.decks.personal.components.layouts.site.SiteLayoutStylesheet.Page
import pl.decks.posthog.client.PostHogClient

const val MAIN_SCROLLING_AREA = "main-scrolling-area"

@InitRoute
internal fun initSiteLayout(ctx: InitRouteContext) {
    ctx.data.addIfAbsent {
        SiteLayoutData(metaTitle = "")
    }
}

enum class CollapsableMenuState {
    CLOSED,
    OPEN,
    CLOSING;

    fun next(): CollapsableMenuState = when (this) {
        CLOSED -> OPEN
        OPEN -> CLOSING
        CLOSING -> CLOSING
    }
}

@Composable
@Layout
fun SiteLayout(ctx: PageContext, content: @Composable SiteLayoutScope.() -> Unit) {
    val data = ctx.data.getValue<SiteLayoutData>()
    val siteScope = remember { SiteLayoutScope(CollapsableMenuState.CLOSED) }
    var previousPath by remember { mutableStateOf<String?>(null) }
    LaunchedEffect(data) {
        if (data.metaTitle.isNotBlank()) {
            document.title = "pi@blaze - ${data.metaTitle}"
        } else {
            document.title = "pi@blaze"
        }
        if (!data.metaDescription.isNullOrBlank()) {
            document.querySelector("""meta[name="description"]""")!!.setAttribute("content", data.metaDescription)
        }
    }

    LaunchedEffect(ctx.route.path) {
        PostHogClient.capture(SiteNavigationJourney.RouteChanged(previousPath, ctx.route.path))
        previousPath = ctx.route.path
    }

    Column(Page.Accented.toModifier()) {
        siteScope.Header()
        Column(
            modifier = Page.HeaderlessScreen.toModifier().weight(1f).id(MAIN_SCROLLING_AREA),
            horizontalAlignment = Alignment.CenterHorizontally,
        ) {
            siteScope.content()
            Spacer()
            Footer(isCopyright = data.isCopyright)
        }
    }
}
